export const css = {
	root: '_3jRrt_-5',
	content: '_2z-8K9xe',
	loading: '_38G74PtM',
	promote: '_39ToyeDv',
	disabledPromote: '_24h0uLGx',
	domain: '_3ofNXx_3',
	title: '_33sw7jNL',
	subtitle: '_2v_zYkdr',
	actions: '_3GObyZIq',
	indicator: '_1FFZM8cy',
	' _key': 'ascm-theme/ascm/card/tgf'
};

export default css;
